<template>
  <a-card :bordered='false'>

    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='7' :sm='8'>
            <a-form-item label='盘号' :labelCol='{span: 8}' :wrapperCol='{span: 14, offset: 1}'>
              <a-select allowClear placeholder='请选择盘号' v-model='queryParam.appSsid'>
                <a-select-option v-for='item in appList' :value='item.appssid' :key='item.appssid'>{{ item.appName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='7' :sm='8'>
            <a-form-item label='引流渠道' :labelCol='{span: 8}' :wrapperCol='{span: 14, offset: 1}'>
              <a-input placeholder='引流渠道，0=不限' v-model='queryParam.channel'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='7' :sm='8'>
            <a-form-item label='强制放款渠道' :labelCol='{span: 8}' :wrapperCol='{span: 14, offset: 1}'>
              <a-select allowClear placeholder='请选择强制放款渠道' v-model='queryParam.payChannel'>
                <a-select-option v-for='item in payChannelList' :value='item.value' :key='item.key'>{{ item.label || item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md='3' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>查询</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <div class='table-operator' style='border-top: 5px'>
        <a-button @click='handleAdd' type='primary' icon='plus'>添加</a-button>
      </div>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        :rowClassName='rowClassName'
        bordered
        @change='handleTableChange'>
        <a-tag slot='allowStatus' slot-scope='text' :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '允许' : '不允许' }}</a-tag>
        <a-tag slot='status' slot-scope='text' :color="text === 1 ? 'green' : 'red'">{{ text === 1 ? '启用' : '禁用' }}</a-tag>
        <span slot='action' slot-scope='text, record'>
          <a @click='handleEdit(record)'>
            <a-icon type='edit' />
            编辑
          </a>
          <template v-if='!isFallbackRow(record)'>
            <a-divider type='vertical' />
            <a-popconfirm title='确定删除吗?' @confirm='() => handleDelete(record.id)'>
              <a>删除</a>
            </a-popconfirm>
          </template>
        </span>
      </a-table>

    </div>
    <payout-ctrl-modal ref='modalForm' @ok='modalFormOk'></payout-ctrl-modal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getPayoutCtrlList, deletePayoutCtrl, getPayoutChannelSelect } from '@/webpublicapi/third'
import { getApplistExcludingSubApp } from '@/webpublicapi/order'
import PayoutCtrlModal from './modules/PayoutCtrlModal'

export default {
  name: 'Payout',
  components: { PayoutCtrlModal },
  data() {
    return {
      dataSource: [],
      loading: false,
      appList: [],
      payChannelList: [],
      // 查询条件
      queryParam: {
        appSsid: undefined,
        channel: '',
        payChannel: undefined
      },
      // 分页参数
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      // 表头
      columns: [
        {
          title: '盘号',
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: '引流渠道',
          align: 'left',
          dataIndex: 'channel'
        },
        {
          title: '强制放款渠道',
          align: 'left',
          dataIndex: 'payChannel'
        },
        {
          title: '允许放款总数',
          align: 'center',
          dataIndex: 'allowTotal'
        },
        {
          title: '是否允许放款',
          align: 'center',
          dataIndex: 'allowStatus',
          scopedSlots: { customRender: 'allowStatus' }
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '更新时间',
          align: 'center',
          dataIndex: 'updatedTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    this.loadData(1)
    this.loadAppList()
    this.loadPayChannelList()
  },
  methods: {
    loadAppList() {
      getApplistExcludingSubApp().then(res => {
        if (res.code === 1000) {
          // 过滤"全部"空值项，前插 '0' 兜底项（'0' 为全盘号兜底配置）
          this.appList = [{ appssid: '0', appName: '0-全部盘号' }]
            .concat((res.data || []).filter(item => item.appssid !== ''))
        }
      })
    },
    loadPayChannelList() {
      getPayoutChannelSelect().then(res => {
        if (res.code === 1000) {
          // 前插 '0' 兜底项（'0' 为不限强制放款渠道）
          this.payChannelList = [{ key: '0', value: '0', label: '0-不限' }].concat(res.data || [])
        }
      })
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams()
      getPayoutCtrlList(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.ipagination.total = res.data.total
          this.dataSource = res.data.rows
        } else {
          this.ipagination.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      var param = Object.assign({}, this.queryParam)
      param.pageNum = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },
    handleTableChange(pagination) {
      this.ipagination = pagination
      this.loadData()
    },
    // (0,0,0) 全局兜底行只允许编辑（放款定时任务依赖全局行），操作列不展示删除按钮
    isFallbackRow(record) {
      return record.appSsid === '0' && record.channel === '0' && record.payChannel === '0'
    },
    // 全局兜底行整行底色提示
    rowClassName(record) {
      return this.isFallbackRow(record) ? 'global-fallback-row' : ''
    },
    handleAdd() {
      this.$refs.modalForm.add()
      this.$refs.modalForm.title = '新增'
    },
    handleEdit(record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
    },
    handleDelete(id) {
      deletePayoutCtrl({ id }).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 重置
    searchReset() {
      this.queryParam = {
        appSsid: undefined,
        channel: '',
        payChannel: undefined
      }
      this.loadData(1)
    },
    // model回调
    modalFormOk() {
      this.loadData()
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";

/deep/ .global-fallback-row td {
  background: #F0FFF0;
}
</style>
